import { useMemo } from 'react';
import { createStaticDataProvider } from '@adv-frontend/data-provider';
import { createFilterSelectWithSuggest, HighlightedText } from '@adv-frontend/filters';
import { type OpenApiSchemaAddonListItem } from '#shared/api/schema';
import { trimAndLowerString } from '#shared/lib/string';
import { useFilterAddonsTitleByValue } from './hooks/useFilterAddonsTitleByValue';
import { useGetAddonsList } from '../api/addons';
import { ADDON_FILTER_SLUG } from './constants';

type AddonFilterItem = { id: OpenApiSchemaAddonListItem['id']; label: OpenApiSchemaAddonListItem['title'] };

export const createAddonFilter = () =>
    createFilterSelectWithSuggest<typeof ADDON_FILTER_SLUG, AddonFilterItem>({
        id: ADDON_FILTER_SLUG,
        title: 'Услуги',
        suggestProps: {
            dataProvider: function Component(props) {
                const searchString = trimAndLowerString(props.queryArg.searchValue);
                const { data: { addons } = { addons: [] } } = useGetAddonsList({});

                const filteredAddons = useMemo(
                    () =>
                        addons
                            .filter((addon) => trimAndLowerString(addon.title).includes(searchString))
                            .map((addon) => {
                                return {
                                    id: addon.id,
                                    label: addon.title,
                                };
                            }),
                    [addons, searchString]
                );

                const dataProvider = useMemo(() => createStaticDataProvider(filteredAddons), [filteredAddons]);

                return props.children(dataProvider);
            },
            useTitleByValue: useFilterAddonsTitleByValue,
            renderSelectListItem: ({ item, search }) => <HighlightedText text={item.label} search={search} joinParts />,
            renderFilterChipsItem: ({ item }) => item.label,
        },
    });
